import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ShieldCheck, BadgeIndianRupee, Lightbulb, Truck } from "lucide-react";
import { SectionHead, FadeUp, CountUp } from "@/components/site/Reveal";
import { WHY, STATS } from "@/data/site";

const ICONS = [ShieldCheck, BadgeIndianRupee, Lightbulb, Truck];

export const Stats = () => (
  <section className="px-6 py-20" data-testid="stats-section">
    <div className="mx-auto max-w-7xl grid grid-cols-2 lg:grid-cols-4 border-y border-white/10">
      {STATS.map((s, i) => (
        <FadeUp key={s.label} delay={i * 0.08} className={`py-12 px-4 lg:px-8 ${i % 2 ? "border-l" : ""} ${i > 0 ? "lg:border-l" : ""} ${i > 1 ? "border-t lg:border-t-0" : ""} border-white/10`}>
          <p className="font-display text-4xl md:text-6xl font-bold neon-text" data-testid={`stat-value-${i}`}><CountUp value={s.value} suffix={s.suffix} /></p>
          <p className="mt-3 text-sm text-[#a5b4c8]">{s.label}</p>
        </FadeUp>
      ))}
    </div>
  </section>
);

export const Why = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} className="px-6 py-28" data-testid="why-section">
      <div className="mx-auto max-w-7xl grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5 relative aspect-[4/5] rounded-[28px] overflow-hidden border border-white/10">
          <motion.img style={{ y, scale: 1.25 }} src="/img/electrician.jpg" alt="Electrician installing a modular switch box with parts from Rama Electricals" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-[#030712]/20 to-transparent" />
          <p className="absolute bottom-6 left-6 right-6 font-display text-2xl">Trusted by electricians across the western suburbs.</p>
        </div>
        <div className="lg:col-span-7">
          <SectionHead eyebrow="02 / Why Rama" title={["Classy store.", "Honest service."]} text="We are more than a counter. We are the electrical partner Goregaon homeowners and contractors call first." />
          <div className="mt-12 grid sm:grid-cols-2 gap-4">
            {WHY.map((w, i) => {
              const Icon = ICONS[i];
              return (
                <FadeUp key={w.title} delay={i * 0.08} className="glass rounded-2xl p-6 transition-colors duration-300 hover:border-[#39FF14]/40">
                  <Icon className="text-[#39FF14]" size={24} />
                  <h3 className="font-display text-xl mt-5">{w.title}</h3>
                  <p className="mt-2 text-sm text-[#a5b4c8] leading-relaxed">{w.text}</p>
                </FadeUp>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
